import { render, staticRenderFns } from "./PersonLight.vue?vue&type=template&id=63699a79&scoped=true&"
import script from "./PersonLight.vue?vue&type=script&lang=js&"
export * from "./PersonLight.vue?vue&type=script&lang=js&"
import style0 from "./PersonLight.vue?vue&type=style&index=0&id=63699a79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63699a79",
  null
  
)

export default component.exports